export enum ChartFamilyEnum {
  TIME = 'TIME',
  COLUMNS = 'COLUMNS',
  PIE = 'PIE'
}

export enum TimeChartTypesEnum {
  LINE = 'LINE',
  HISTOGRAM = 'STACKEDBAR'
}

export enum ChartTypesEnum {
  LINE = 'LINE',
  HISTOGRAM = 'STACKEDBAR',
  AREA = 'AREA',
  SQUARE_WAVE = 'STEPLINE',
}

export enum BucketUnitEnum {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  YEARS = 'YEARS'
}

export enum AggregateFunctionTypeEnum {
  MEAN = 'MEAN',
  MIN = 'MIN',
  MAX = 'MAX',
  FIRST = 'FIRST',
  LAST = 'LAST',
  SUM = 'SUM',
  COUNT = 'COUNT',
}
